import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store/root-reducer';

import { validateDraft } from '../domain/api-key-draft.validation';

const selectEditApiKey = (state: RootState) => state.editApiKey;

export const selectApiKey = (state: RootState) => selectEditApiKey(state).apiKey;
export const selectDraft = (state: RootState) => selectEditApiKey(state).draft;
export const selectLoadStatus = (state: RootState) => selectEditApiKey(state).loadStatus;
export const selectSaveStatus = (state: RootState) => selectEditApiKey(state).saveStatus;
export const selectError = (state: RootState) => selectEditApiKey(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectEditApiKey(state).validationErrors;

export const selectIsSaving = (state: RootState) =>
  selectEditApiKey(state).saveStatus === 'saving';
export const selectLoadFailed = (state: RootState) =>
  selectEditApiKey(state).loadStatus === 'failed';

/** Derived: is the current draft valid? Memoised on the draft reference. */
export const selectIsDraftValid = createSelector(
  selectDraft,
  (draft) => Object.keys(validateDraft(draft)).length === 0,
);
